// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__GiL3v","img":"style_img__C1gt+"};